import React, { useState, useCallback } from "react";
import { addDomainToCart } from "features/common/layouts/cartSlice";
import { useDispatch, useSelector } from "react-redux";
// import custom from "../../../assets/scss/Domain.module.scss"; // File sudah dihapus
import { notifyWarning, notifySuccess } from "components/ToastMessage";
import ErrorBoundary from "components/ErrorBoundary";

const ExistingDomain = (props) => {
  const { domainMethod, setDomainMethod } = props;
  const dispatch = useDispatch();
  const [domain, setDomain] = useState("");
  const { productsList: cartItems } = useSelector((state) => state.cart);


  // const additionalValidTlds = [".desa.id", ".go.id", ".mil.id", ".net.id"];

  // const options = (props.extOption || []).map((option) => ({
  //   value: option[1],
  //   label: option[1],
  //   price: option[4],
  // }));

  const handleClick = () => {
    try {
      if (domain && domain.trim() !== "") {
        // Bersihkan domain input
        const cleanDomain = domain.trim().toLowerCase();
        
        // Validasi dasar untuk existing domain - hanya cek format minimal
        if (!cleanDomain.includes(".")) {
          notifyWarning("Domain tidak valid!");
          return;
        }

        // Validasi hosting di cart - WAJIB untuk existing domain
        const hasHostingOrResellerInCart = cartItems.find(
          (item) => item.type === "hostingaccount" || item.type === "reselleraccount"
        );

        // Untuk existing domain, tetap harus ada hosting di cart
        if (!hasHostingOrResellerInCart) {
          notifyWarning("Anda harus memilih hosting terlebih dahulu sebelum menggunakan domain existing!");
          return;
        }

        // Untuk existing domain, tidak perlu validasi ketat karena user sudah memiliki domain
        // Hanya cek format dasar
        const splitDomain = cleanDomain.split(".");
        if (splitDomain.length < 2) {
          notifyWarning("Domain tidak valid!");
          return;
        }

        // Validasi karakter tidak valid - hanya karakter yang benar-benar tidak valid
        if (/[<> !@#$%^&*()_+=;:?/\\|}{\][~`]/.test(cleanDomain)) {
          notifyWarning("Domain mengandung karakter tidak valid!");
          return;
        }

        // Tambahkan domain ke cart
        dispatch(addDomainToCart({ 
          domain: cleanDomain, 
          type: "domain-existing"
        }));
        notifySuccess(`${cleanDomain} Berhasil ditambahkan!`);
      } else {
        notifyWarning("Silakan masukkan nama domain terlebih dahulu!");
      }
    } catch (error) {
      console.warn("Error in handleClick:", error);
      notifyWarning("Terjadi kesalahan saat menambahkan domain!");
    }
  };

  const handleMethodChange = useCallback(() => {
      setDomainMethod("existing");
  }, [setDomainMethod]);

  return (
    <ErrorBoundary>
      <div className="card mb-3 shadow-sm" style={{ minHeight: "100px", borderRadius: "16px", borderColor: "transparent" }}>
        <div className="card-body">
          <div className="form-check mb-3 py-1 px-4">
            <input
              type="radio"
              className="form-check-input"
              name="domainMethod"
              id="existingDomain"
              value="existing"
              checked={domainMethod === "existing"}
              onChange={handleMethodChange}
            />
            <label
              htmlFor="existingDomain"
              className="form-check-label fw-bold"
              style={{ fontSize: "18px", marginLeft: "20px" }}
            >
              Gunakan domain yang sudah saya miliki
            </label>
            <p className="mb-0 mt-2" style={{ marginLeft: "21px", marginTop: "6px" }}>
              Domain Qwords sebelumnya bisa digunakan disini
            </p>

            {domainMethod === "existing" && (
              <div className="mt-3">
                <div className="row g-3">
                  <div className="col-12 col-md-9">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nama Domain Anda"
                    onChange={(e) => setDomain(e.target.value)}
                    value={domain}
                  />
                  </div>
                  <div className="col-12 col-md-3">
                    <button 
                      type="button"
                      className="btn btn-cta w-100 rounded-5" 
                      onClick={handleClick}
                      disabled={!domain || domain.trim() === ""}
                    >
                      Gunakan
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default ExistingDomain;